class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    if (!this.mainDetailsToggle) {
      return;
    }

    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    // Bind the handlers once and store them
    this.boundOpen = this.open.bind(this);
    this.boundClose = this.close.bind(this);

    this.updateHoverBehavior();
  }

  updateHoverBehavior() {
    const isHoverEnabled = this.hasAttribute('data-hover-enabled');

    // Remove previous listeners
    this.mainDetailsToggle.removeEventListener('mouseenter', this.boundOpen);
    this.mainDetailsToggle.removeEventListener('mouseleave', this.boundClose);

    // Add new listeners only if hover is enabled and is desktop
    if (isHoverEnabled && window.matchMedia('(min-width: 1024px)').matches) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.boundOpen);
      this.mainDetailsToggle.addEventListener('mouseleave', this.boundClose);
    }
  }

  static get observedAttributes() {
    return ['data-hover-enabled'];
  }

  attributeChangedCallback(name) {
    if (name === 'data-hover-enabled') {
      this.updateHoverBehavior();
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

class HeaderSubMenu extends DetailsDisclosure {
  constructor() {
    super();
  }
}

customElements.define('header-submenu', HeaderSubMenu);

